<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class=" d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-users text-primary"></i> Batch</h5>
      </div>
      <hr>
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Batch<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Batch">
        </div>
        <div class=" col-md-3">
          <label class="form-label">Year<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.Year">
              <option selected="" value="">Select Year</option>
              <option v-for="year in academicYears" :key="year" :value="year">{{ year }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6 text-end mt-1">
        <button class="btn btn-sm btn-darknavy me-1" @click="save()"><i class="fa fa-save"></i> Save</button>
        <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
      </div>
      <div class="row">
        <div class="col-md-7 table-responsive mt-2" style="margin-top:5px ;">
           <ul v-if="errors.length" class="text-danger ps-3">
        <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
      </ul>
      <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
        <DataTable v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
          </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Year" @delRecord="delRecord" @closeModal="delObj.Year = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
  const  Obj = ref( { Batch: "", Year: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Batch', key: 'Batch' },
  { label: 'Year', key: 'Year' }
]);
const handleEdit = (row) => {
    Obj.value = { ...row }
}
const currentYear = new Date().getFullYear();
const academicYears = ref(
  Array.from({ length: 5 }, (_, i) => {
    const start = currentYear + i;
    const end = start + 1;
    return `${start}-${end}`;
  })
);
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
     const  save =async() => {
      const fields = {
        Batch: { value: Obj.value.Batch, validators: [isRequired], },
        Year: { value: Obj.value.Year, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
     const idx1 = rows.value.find( item => item.Batch.toLowerCase().trim() === Obj.value.Batch.toLowerCase().trim() && item._id !== Obj.value._id );
      const idx = rows.value.find( item => item.Year === Obj.value.Year && item._id !== Obj.value._id );
      if (idx1) { msgObj.value = { msg: "Batch already exists.", role: "danger", show: true }; return; }
      if (idx) { msgObj.value = { msg: "Year already exists.", role: "danger", show: true }; return; }
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/Batch${url}`, Obj.value)
          .then(() => {
            loadData();
            reset();
            msgObj.value = { msg: `Batch ${msg} Successfuly`, role: "success", show: true, };
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
const reset =async () =>{
      Obj.value = { Batch: "", Year: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
     const progress = ref(0)
const loadData =async () => {
      let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/Batch/all') .then((response) => { 
        rows.value = response.data.slice().sort((a, b) => a.Year.localeCompare(b.Year)).map((item, i) => ({ ...item, Sno: i + 1 }));
        progress.value = 0
          clearInterval(progressInterval) 
      });
    }
 const delRecord =async () => {
      await api.delete(`/Batch/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "Batch Deleted Successfuly.", role: "danger", show: true, };
        });
    }
 onMounted(() => { loadData() })
</script>